import React, { useContext, useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import { Box, IconButton } from '@mui/material';
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../firebaseConfig/firebase.config';

import { RecordContext } from '../record-context';
import getCroppedImg from './create-croped-image'
import { useNotify } from '../../hooks/use-notify';
import { useStyles } from './styles';
import zoomInIcon from '../../images/icons/zoom-in.svg';
import zoomOutIcon from '../../images/icons/zoom-out.svg';
import saveIcon from '../../images/icons/save2.svg';
import editIcon from '../../images/icons/edit.svg';
import closeIcon from '../../images/icons/close.svg';
import { updateAction } from '../action/updateAction';
import { useGetImageMeta } from '../../hooks/use-get-image-meta';

export const StepImageCropper = ({ image, step, setIsDragDisabled }) => {
  const [showCropper, setShowCropper] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState({ width: 768, height: 768 });
  const [zoom, setZoom] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({ x: 0, y: 0, width: 796, height: 796 });
  const classes = useStyles();
  const { record, recordDispatch } = useContext(RecordContext);

  useEffect(() => {
    useGetImageMeta(
      image,
      (width, height) => {
        setCroppedAreaPixels(prev => (
            {
              ...prev,
              width,
              height
            }
          )
        )
        setSize({ width, height })
      }
    );
  }, []);

  useEffect(() => {
    if (showCropper) {
      setIsDragDisabled(true);
    } else {
      setIsDragDisabled(false);
    }
  }, [showCropper, zoom])

  const [ notify ] = useNotify();

  const onCropComplete = useCallback(
    (
      croppedArea,
      croppedAreaPixels
    ) => {
      setCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  const getImage = async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);

      const timestamp = Number(new Date());
      const storageRef = ref(storage, `images/${timestamp}`);
      const arr = record.arr;
      setIsLoading(true);
      uploadBytesResumable(storageRef, croppedImage)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref).then((url) => {
            arr[arr.indexOf(step)].imageURL = url;
            recordDispatch(updateAction({
              ...record,
              arr,
              needSave: true
            }));
            setIsLoading(false);
            setShowCropper(false);
            setTimeout(() => {
              setZoom(1)
            },1050)
            notify('Image success changed!');
          });
        }).catch(() => {
        notify('Image change failed', 'error');
      });

    } catch (e) {
      console.error(e);
    }
  };

  const zoomIn = () => {
    setZoom(prevState => {
      if (zoom < 2) {
        return  prevState + 0.125
      } else {
        return 2
      }
    })
  }

  const zoomOut = () => {
    setZoom(prevState => {
      if (zoom > 1) {
        return  prevState - 0.125
      } else {
        return 1
      }
    })
  }

  return (
    <>

      <Box className={classes.cropperWrapper}>
        {
          showCropper &&
            <>
              <Cropper
                aspect={size.width / size.height}
                crop={crop}
                image={image}
                objectFit='auto-cover'
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
                zoom={zoom}
                showGrid={showCropper}
              />
              <Box className={classes.imageControlsClose}>
                <IconButton onClick={() => {
                  setShowCropper(false);
                  setZoom(1);
                }}>
                  <img src={closeIcon} alt="close"/>
                </IconButton>
              </Box>
            </>
          }
        <img style={{width: "100%", visibility: showCropper ? "hidden" : "inherit"}} src={step.imageURL} alt={step.name}/>
        <Box className={classes.imageControls}>
          {
            showCropper ?
              <>
                <IconButton onClick={zoomIn}>
                  <img src={zoomInIcon} alt="zoom in"/>
                </IconButton>
                <IconButton onClick={zoomOut}>
                  <img src={zoomOutIcon} alt="zoom out"/>
                </IconButton>
                <IconButton className={classes.imageIconButton + ( isLoading ? ' loading' : '')} onClick={getImage} disabled={zoom === 1}>
                  <img src={saveIcon} className={classes.imageIconSave} alt="save"/>
                </IconButton>
              </> :
              <IconButton onClick={() => setShowCropper(true)}>
                <img src={editIcon} alt="edit"/>
              </IconButton>
          }
        </Box>
      </Box>
    </>
  )
}